module.exports = __webpack_public_path__ + "static/media/17.2d948d56.jpg";